import { render } from "./TargetDefinition.vue?vue&type=template&id=573d199b&scoped=true&ts=true"
import script from "./TargetDefinition.vue?vue&type=script&lang=ts"
export * from "./TargetDefinition.vue?vue&type=script&lang=ts"

import "./TargetDefinition.vue?vue&type=style&index=0&id=573d199b&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573d199b"]])

export default __exports__